import { resolveCurrentUser } from '@/modules/user/user.service';
import { NOTIFICATION_URL } from '@/modules/notification/notification.contants';

export default [
  {
    ...NOTIFICATION_URL,
    beforeEnter: resolveCurrentUser,
    component: () => import('@/modules/notification/views/NotificationListPage.vue'),
  },
];
